import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { OnGoingReportService } from './ogreport.service';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
@Component({
    moduleId: module.id,
    templateUrl: './ogreport.html',
    styleUrls: ['ogreport.component.css']
})
export class OnGoingReportComponent implements OnInit {
    @ViewChild('dropdownRef') dropdownRef: AngularMultiSelect;
    topScrollWidth: number;
    dataLoaded: boolean;
    public loading = false;
    ogReportForm: FormGroup;
    private controlGroupControl: FormControl;
    private measurementEndDateControl: FormControl;
    private measurementStartDateControl: FormControl;
    private avgWeeklyThresholdControl: FormControl;
    private typeOfHoursControl: FormControl;
    downloadPdfInProgress: boolean = false;
    downloadExcelInProgress: boolean = false;
    measurementStartDates: Array<string>;
    measurementEndDates: Array<string>;
    controlGroups: any = [];
    typeOfHours: Array<string>;
    errorMessage: string;
    countWeeks: string;
    countMonths: string;


    // TODO - use of below?
    public count13Weeks: any;
    public count26Weeks: any;
    public count47Weeks: any;
    // end
    avgWeeklyThreshold: Array<string>;
    workDetails: Array<any> = [];

    @ViewChild('topScroll') topScroll: ElementRef;
    @ViewChild('bottomScroll') bottomScroll: ElementRef;

    public rows: Array<any> = [];
    public columns: Array<any> = [
        { title: 'Controlled Group', className: 'va-m', name: 'controlGroup' },
        { title: 'Latest Production Company', className: 'va-m', name: 'mostRecentProductionCompany' },
        { title: 'Most Recent Show', className: 'va-m', name: 'mostRecentProject' },
        { title: 'SSN', className: 'hidden-xs va-m', name: 'ssnNumber' },
        { title: 'First Name', className: 'hidden-xs va-m', name: 'firstName' },
        { title: 'Last Name', className: 'va-m', name: 'lastName' },
        { title: 'Email Id', className: 'va-m', name: 'emailId' },
        { title: 'Last Worked Date', className: 'va-m', name: 'lastWorkedDate' },
        { title: 'Hire Date', className: 'va-m', name: 'hireDate' },
        { title: 'Union Status', className: 'va-m', name: 'unionType' },
        { title: 'Union Name', className: 'va-m', name: 'unionName' },
        { title: 'Weeks Since Last Worked', className: 'va-m', name: 'weeksSinceLastWorked' },
        { title: 'Average Hours SMP', className: 'va-m', name: 'avgHours' },
        { title: 'Total Hours', className: 'va-m', name: 'totalHours' },
        { title: 'ACA Employment Status', className: 'va-m', name: 'acaEmploymentStatus' },
        { title: 'Payroll Source', className: 'va-m', name: 'payrollSource' },
        { title: 'Employee Type', className: 'va-m', name: 'employeeType' },
        { title: 'Date Of Birth', className: 'va-m', name: 'dateOfBirth' },
        { title: 'Rate Of Pay Unit', className: 'va-m', name: 'rateOfPayUnit' },
        { title: 'Resident Address1', className: 'va-m', name: 'address1' },
        { title: 'Resident Address2', className: 'va-m', name: 'address2' },
        { title: 'City', className: 'va-m', name: 'residentCity' },
        { title: 'State', className: 'va-m', name: 'residentState' },
        { title: 'Country', className: 'va-m', name: 'residentCountry' },
        { title: 'Zipcode', className: 'va-m', name: 'residentZip' },
        { title: 'Employee ID', className: 'va-m', name: 'employeeId' },
        { title: 'Pay Cycle', className: 'va-m', name: 'payCycle' },
        { title: 'Employee Status', className: 'va-m', name: 'employeeStatus' },
    ];
    public page: number = 1;
    public itemsPerPage: number = 10;
    public maxSize: number = 5;
    public numPages: number = 1;
    public length: number = 0;

    public config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table', 'table-striped', 'table-bordered', 'table-hover']
    };
    userData: any;
    cgDropdownSettings = {};
    selectedCgValue: any =[];
    showfiltererror: boolean = false;
    downloadexcel:any;
    downloadpdf:any;
    isfilterloaded: boolean = false;
    constructor(private _ogreportsrv: OnGoingReportService) {
        this.userData = JSON.parse(localStorage.getItem('token'));
    }

    ngOnInit(): void {
        this.cgDropdownSettings = {
            singleSelection: false,
            text: 'Select Controlled Group',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            classes: 'myclass custom-class single-dropdown',
            badgeShowLimit: 3
        };
        this.setFilterData()

        if (localStorage.getItem('storedData')) {
            this.onloadData();
        }
        this.countWeeks = '0';
        this.controlGroupControl = new FormControl('', Validators.required);
        this.typeOfHoursControl = new FormControl('', Validators.required);
        this.measurementStartDateControl = new FormControl('', Validators.required);
        this.measurementEndDateControl = new FormControl('', Validators.required);
        this.avgWeeklyThreshold = ['>=30', '<30'];
        this.avgWeeklyThresholdControl = new FormControl('', Validators.required);

        //  this.selectedweekCount = 0;
        this.ogReportForm = new FormGroup(
            {
                controlGroup: this.controlGroupControl,
                typeOfHour: this.typeOfHoursControl,
                avgWeeklyHoursThreshold: this.avgWeeklyThresholdControl,
                measurementEndDate: this.measurementEndDateControl,
                measurementStartDate: this.measurementStartDateControl
            }
        );
        this.countWeeks = '0';
        this.countMonths = '0';
        this.onChangeTable(this.config);
        this.reset();

        //this.dataLoaded = false;
    }

    endDatesOfCG($event:any) {
        if(this.selectedCgValue[0]){
            this.controlGroupControl.setValue(this.selectedCgValue[0].itemName);
            this._ogreportsrv.getEndDatesOfCG(this.controlGroupControl.value).subscribe(data => {
                this.measurementStartDates = data.measurementStartDatesByControlGroupList;
                this.measurementEndDates = data.measurementEndDatesByControlGroupList;
            }, error => this.errorMessage = <any>error);
        }else{
            this.controlGroupControl.setValue('');
            this.measurementStartDates = [];
            this.measurementEndDates = [];
        }
    }
    onloadData(): void {
        const ssnData = JSON.parse(localStorage.getItem('storedData'));
        this.loading = true;
        this._ogreportsrv.getSSnData(ssnData).subscribe(data => {
            this.loading = false;
            this.dataLoaded = true;
            this.workDetails = data;
            this.onChangeTable(this.config);
            this.topScrollWidth = this.bottomScroll.nativeElement.scrollWidth;
        },
            error => this.errorMessage = <any>error);
    }
    reset(): void {
        this.typeOfHoursControl.setValue('');
        this.measurementEndDateControl.setValue('');
        this.measurementStartDateControl.setValue('');
        this.avgWeeklyThresholdControl.setValue('');
        this.dataLoaded = false;
        this.countWeeks = '0';
        this.countMonths = '0';
        this.dataLoaded = false;
        this.showfiltererror = false;
        if(this.userData.principal.roles[0] !== 'User' || this.userData.principal.controlGroups.length > 1){
            this.controlGroupControl.setValue('');
            this.selectedCgValue = [];
        }
    }

    getFilterValues(): any {
        let measurementStartDate = this.measurementStartDateControl.value;
        if (measurementStartDate === undefined || measurementStartDate === '') {
            measurementStartDate = '\'\'';
        }
        let measurementEndDate = this.measurementEndDateControl.value;
        if (measurementEndDate === undefined || measurementEndDate === '') {
            measurementEndDate = '\'\'';
        }
        let cg = this.controlGroupControl.value;
        if (cg === undefined || cg === "All" || cg === '') {
            cg = '\'\'';
        }
        let emptype = this.typeOfHoursControl.value;
        if (emptype === undefined || emptype === '') {
            emptype = '\'\'';
        }
        let cat = this.avgWeeklyThresholdControl.value;
        if (cat === undefined || cat === '') {
            cat = '\'\'';
        }
        let filterCriteria: any = {
            selectedMeasuredStartDate: measurementStartDate,
            selectedMeasuredEndDate: measurementEndDate,
            selectedControlGroup: this.selectedCgValue.map((e:any)=>{return e.itemName}).join(":"),
            selectedTypeOfHours: emptype,
            avgWeeklyThreshold: cat,
            reportCount: this.countWeeks
        };
        return filterCriteria;
    }

    getCount(): void {
        let filterCriteria = this.getFilterValues();
        this.countWeeks = '0';
        this.countMonths = '0';
        this._ogreportsrv.getOnGoingReportDataCount(filterCriteria).subscribe(data => {
            this.countMonths = data.onGoingMonthDiffCount;
            if (data.onGoingReportCount == undefined)
                this.countWeeks = '0';
            else
                this.countWeeks = data.onGoingReportCount;
        },
            (error: any) => this.errorMessage = <any>error);
    }

    Search(item: number = 0): void {
        this.page = 1
        this.showfiltererror = false;
        let filterCriteria = this.getFilterValues();
        if ((filterCriteria.selectedMeasuredStartDate.length === 2) || (filterCriteria.selectedMeasuredEndDate.length === 2) || !filterCriteria.selectedControlGroup) {
            this.showfiltererror = true;
            return
        }
        this.loading = true;
        this.dataLoaded = true;
        this.isfilterloaded = true;
        console.log(filterCriteria)
        this._ogreportsrv.getOnGoingReportData(filterCriteria).subscribe(data => {
            this.getCount()
            this.loading = false;
            this.workDetails = data;
            this.onChangeTable(this.config);
            this.topScrollWidth = this.bottomScroll.nativeElement.scrollWidth+100;
            this.dataLoaded = true;
            this.isfilterloaded = false;
        },
            error => this.errorMessage = <any>error);
    }

    downloadPdf(): void {
        this.downloadpdf = true;
        let filterCriteria = this.getFilterValues();
            this.showfiltererror = false;
            this._ogreportsrv.downloadPDFReport(filterCriteria).subscribe((data:any) => {
                this.downloadpdf = false;
            }, (err:any) => (this.downloadpdf = false))
    }

    downloadExcel(): void {
        this.downloadexcel = true;
        let filterCriteria = this.getFilterValues();
            this.showfiltererror = false;
            this._ogreportsrv.downloadExcelReport(filterCriteria).subscribe((data:any) => {
                this.downloadexcel = false;
            }, (err:any) => (this.downloadexcel = false))
    }
    // Validations

    validateControlGroups(): boolean {
        return this.controlGroupControl.valid || this.controlGroupControl.untouched;
    }

    validateMeasurementEndDate(): boolean {
        return this.measurementEndDateControl.valid || this.measurementEndDateControl.untouched;
    }

    validateAvgThreashold(): boolean {
        return this.avgWeeklyThresholdControl.valid || this.avgWeeklyThresholdControl.untouched;
    }

    validateTypeOfHour(): boolean {
        return this.typeOfHoursControl.valid || this.typeOfHoursControl.untouched;
    }

    public onCellClick(data: any): any {
    }
    public changePage(page: any, data: Array<any> = this.workDetails): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
        return data.slice(start, end);
    }
    public changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;
        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString, 'i');
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) =>
                item[config.filtering.columnName].match(new RegExp(this.config.filtering.filterString, 'i')));
        }

        let tempArray: Array<any> = [];
        filteredData.forEach((item: any) => {
            let flag = false;
            this.columns.forEach((column: any) => {
                if (item[column.name] == null) {
                    item[column.name] = '';
                }
            });
            this.columns.forEach((column: any) => {
                if (item[column.name].toLowerCase().match(new RegExp(this.config.filtering.filterString, 'i'))) {
                    flag = true;
                }
                else if (item[column.name].toUpperCase().match(new RegExp(this.config.filtering.filterString, 'i'))) {
                    flag = true;
                }
            });
            if (flag) {
                tempArray.push(item);
            }
        });
        filteredData = tempArray;

        return filteredData;
    }
    public changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns || [];
        let columnName: string = void 0;
        let sort: string = void 0;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }
            return 0;
        });
    }
    public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.workDetails, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }
    arescrolling = 0;
    scroller(from: any, to: any) {
        if (this.arescrolling) return; // avoid potential recursion/inefficiency
        this.arescrolling = 1;
        from.scrollLeft = to.scrollLeft;
        this.arescrolling = 0;
    }
    ngOnDestroy() {
        localStorage.removeItem('storedData')
    }
    // onItemSelect(item: any) {
    //     this.dropdownRef.closeDropdown()
    //  }
    setFilterData(){
        if(this.userData.principal.roles[0] == 'User' && this.userData.principal.controlGroups.length == 1){
            this.cgDropdownSettings['disabled'] = true;
            this.cgDropdownSettings = Object.assign({}, this.cgDropdownSettings);
            this.selectedCgValue = [{id:this.userData.principal.controlGroups[0], itemName:this.userData.principal.controlGroups[0]}]
            this._ogreportsrv.getEndDatesOfCG(this.userData.principal.controlGroups[0]).subscribe(data => {
                this.measurementStartDates = data.measurementStartDatesByControlGroupList;
                this.measurementEndDates = data.measurementEndDatesByControlGroupList;
                this.controlGroupControl.setValue(this.userData.principal.controlGroups[0]);
            }, error => this.errorMessage = <any>error);
        }else if(this.userData.principal.roles[0] != 'User' || this.userData.principal.controlGroups.length > 1){
            this._ogreportsrv.getReportData().subscribe(data => {
                if(this.userData.principal.roles[0] != 'User'){
                    this.controlGroups = data.ControlGroup.map((element:any) => {return {id:element,itemName:element}});
                }else{
                    this.controlGroups = this.userData.principal.controlGroups.filter((val:any) => data.ControlGroup.includes(val)).map((element:any) => {return {id:element,itemName:element}});
                }
                this.typeOfHours = data.typeOfHours;
            },
                error => this.errorMessage = <any>error);
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/ongoingreport/ogreport.component.ts